document.addEventListener('DOMContentLoaded', () => {
  /* ======================================================
     MEGA MENU HOVER LOGIC
     ====================================================== */

  const navItems = document.querySelectorAll('.io-nav-item.has-mega');

  navItems.forEach(item => {
    let timeout;

    item.addEventListener('mouseenter', () => {
      clearTimeout(timeout);
      item.classList.add('is-active');
    });

    item.addEventListener('mouseleave', () => {
      timeout = setTimeout(() => {
        item.classList.remove('is-active');
      }, 120);
    });
  });

  /* ======================================================
     MOBILE DRAWER TOGGLE
     ====================================================== */
  
  const drawer = document.getElementById('MobileNav');
  const openBtn = document.querySelector('.js-mobile-nav-toggle'); // The hamburger we added earlier
  const closeBtns = document.querySelectorAll('.js-mobile-nav-close'); // The X button and the backdrop

  if (drawer && openBtn) {
    
    // Open Drawer
    openBtn.addEventListener('click', (e) => {
      e.preventDefault();
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
    });

    // Close Drawer (Loop through close buttons)
    closeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        drawer.classList.remove('is-open');
        document.body.style.overflow = ''; // Restore scrolling
      });
    });
  }

  /* ======================================================
     STICKY HEADER LOGIC (WITH CONTENT OFFSET)
     ====================================================== */

  const header = document.querySelector('.site-header.io-header');
  const main = document.querySelector('#MainContent');

  if (!header || !main) return;

  const stickyOffset = header.offsetTop;

  const updateOffset = () => {
    if (header.classList.contains('is-sticky')) {
      main.style.paddingTop = `${header.offsetHeight}px`;
    } else {
      main.style.paddingTop = '';
    }
  };

  const handleSticky = () => {
    if (window.scrollY > stickyOffset) {
      if (!header.classList.contains('is-sticky')) {
        header.classList.add('is-sticky');
        updateOffset();
      }
    } else {
      header.classList.remove('is-sticky');
      updateOffset();
    }
  };

  window.addEventListener('scroll', handleSticky);
  window.addEventListener('resize', updateOffset);
});
